import { css } from '@emotion/react';
import React from 'react';

import SideNavItem from './components/SideNavItem';

const SideNavList = css`
  list-style: none;
  padding: 0;
  margin: 0;

  display: flex;
  flex-direction: column;
`;

function SideNav({ pages = [] }) {
  return (
    <>
      {pages.length === 0 ? null : (
        <nav aria-label="Account">
          <ul css={SideNavList}>
            {pages.map(page => {
              return <SideNavItem title={page.title} path={page.path} key={page.path} />;
            })}
          </ul>
        </nav>
      )}
    </>
  );
}

export default SideNav;
